<div>
  <button
    class="closebtn pull-right"
    mat-button
    color="accent"
    (click)="onCloseClick()"
    id="bucket-items-delete-dialog-btn-close"
  >
    <span class="icon-ic-close popup_close"></span>
  </button>
  <h5 class="p-20 m-0 header font-xxl">{{header}}</h5>

  <div class="message m-b-s align font-l">{{message}}</div>

  <div class="btn-wrapper">
    <button
      mat-button
      color="primary"
      class="confirm-btn primary-hover"
      mat-raised-button
      (click)="deleteFolder()"
      id="bucket-items-delete-dialog-btn-confirm"
    >
      Yes
    </button>
    <button
      mat-button
      color="primary"
      class="mat-button btn-width secondary-hover w-120"
      (click)="onCloseClick()"
      id="bucket-items-delete-dialog-btn-cancel"
    >
      No
    </button>
  </div>
</div>
